import { Box, Center } from "@mantine/core";
import { Navbar } from "../Navbar/Navbar";
import { Footer } from "../Footer/Footer";

export const DefaultLayout = ({
    showNavBar,
    showSearchBar,
    showFooter,
    children,
}: {
    showNavBar: boolean;
    showSearchBar: boolean;
    showFooter: boolean;
    children: React.ReactNode;
}): JSX.Element => {
    return (
        <Box style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
            <Center>
                <Box style={{ width: "100%", maxWidth: "120em", margin: "0 auto" }}>
                    {showNavBar ? <Navbar showSearchBar={showSearchBar} /> : null}

                    <Box className="default-layout" style={{ height: "auto", minHeight: "70vh" }}>{children}</Box>

                    {showFooter ? <Footer /> : null}
                </Box>
            </Center>
        </Box>
    );
};  